<div class="main-wrap" *ngIf="booking">
  <div class="left-box">
    <p-toast></p-toast>
    <p-confirmDialog header="Confirmation" icon="pi pi-info"></p-confirmDialog>
    Booking ID: {{booking.id}}

    <div [formGroup]="bookingForm" class="booking-form">
      <div class="input-box">
        <p>
          First name
        </p>
        <input type="text" formControlName="firstName">
      </div>
      <div class="input-box">
        <p>
          Last name
        </p>
        <input type="text" formControlName="lastName">
      </div>
      <div class="input-box">
        Start date
        <input type="date" formControlName="startDate">
      </div>
      <div class="input-box">
        End date
        <input type="date" formControlName="endDate">
      </div>
      <div class="input-box" *ngIf="duration > 1">
        <p>
          Duration: {{duration}} weeks
        </p>
      </div>
      <div class="input-box">
        <p>
          Language of vademecum
        </p>
        <div *ngIf="bookingForm">
            <select formControlName="studentLanguage" [compareWith]="compareId">
                <option *ngFor="let studentLanguage of studentLanguages" [ngValue]="studentLanguage">
                      {{studentLanguage.name}}
                </option>
              </select>
        </div>

      </div>


    </div>
    <div class="personal-form" [formGroup]="personalForm" *ngIf="bookingService.hasVademecum && personalForm">

      <div class="input-box">
        Student GSM
        <input type="text" formControlName="studentMobile">
      </div>

      <div class="input-box">
        First parent GSM
        <input type="text" formControlName="firstParentMobile">
      </div>

      <div class="input-box">
        Second parent GSM
        <input type="text" formControlName="secondParentMobile">
      </div>

      <div class="input-box">
        First parent first name
        <input type="text" formControlName="firstParentFirstName">
      </div>

      <div class="input-box">
        First parent last name
        <input type="text" formControlName="firstParentLastName">
      </div>

      <div class="input-box">
        Second parent first name
        <input type="text" formControlName="secondParentFirstName">
      </div>

      <div class="input-box">
        Second parent last name
        <input type="text" formControlName="secondParentLastName">
      </div>


    </div>
    <div class="button-container">
      <div class="p-button-wrap">
          <p-button icon="pi pi-replay" label="Restore this booking" (onClick)="restore()" styleClass="p-button-success"></p-button>
      </div>

    </div>
  </div>
  <div class="right-box">
      Created by: {{booking.createdBy!.name}}
      <br>
      Created time: {{booking.created!.toDate() | date: "dd/MM/yyyy 'at' HH:mm:ss"}}

      <br>
      <!-- Deleted by: {{booking.lastModifiedBy.name}} -->
      <br>
      <!-- Deleted time: {{booking.lastModified | date: "dd/MM/yyyy 'at' HH:mm:ss"}} -->
  </div>



</div>
